exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._34vvcetU2yiq6Ub4OySCsf{padding:10px}._34vvcetU2yiq6Ub4OySCsf .ms-Persona-details{-webkit-touch-callout:text;-webkit-user-select:text;-moz-user-select:text;-ms-user-select:text;user-select:text;cursor:auto}", ""]);

// exports
exports.locals = {
	"container": "_34vvcetU2yiq6Ub4OySCsf"
};